<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <h6>語系設定</h6>
            <button
              class="btn btn-primary btn-sm mb-3"
              data-bs-toggle="modal"
              data-bs-target="#languageModal"
              @click="openModal()"
              v-if="can('system.settings')"
            >
              新增語系
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      代碼
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      名稱
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      預設
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="lang in languages" :key="lang.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ lang.code }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ lang.name }}
                      </p>
                      <p class="text-xs text-secondary mb-0">
                        {{ lang.native_name }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-sm"
                        :class="
                          lang.is_active
                            ? 'bg-gradient-success'
                            : 'bg-gradient-secondary'
                        "
                        style="cursor: pointer"
                        @click="toggleActive(lang)"
                      >
                        {{ lang.is_active ? "啟用" : "停用" }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-sm"
                        :class="
                          lang.is_default
                            ? 'bg-gradient-primary'
                            : 'bg-gradient-secondary'
                        "
                        style="cursor: pointer"
                        @click="setDefault(lang)"
                      >
                        {{ lang.is_default ? "預設" : "非預設" }}
                      </span>
                    </td>
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs"
                        @click="openModal(lang)"
                      >
                        編輯
                      </a>
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs ms-3"
                        @click="
                          $router.push({
                            name: 'Translations',
                            params: { languageId: lang.id },
                          })
                        "
                      >
                        翻譯
                      </a>
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs ms-3"
                        v-if="!lang.is_default"
                        @click="deleteLanguage(lang.id)"
                      >
                        刪除
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="languageModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="languageModalLabel"
      aria-hidden="true"
      ref="languageModal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="languageModalLabel">
              {{ isEditing ? "編輯語系" : "新增語系" }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="code" class="col-form-label">代碼 (Code):</label>
                <input
                  type="text"
                  class="form-control"
                  id="code"
                  v-model="form.code"
                  :disabled="isEditing"
                  placeholder="en, zh-TW"
                />
              </div>
              <div class="form-group">
                <label for="name" class="col-form-label"
                  >名稱 (English Name):</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  v-model="form.name"
                  placeholder="English"
                />
              </div>
              <div class="form-group">
                <label for="native_name" class="col-form-label"
                  >原生名稱 (Native Name):</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="native_name"
                  v-model="form.native_name"
                  placeholder="English"
                />
              </div>
              <div class="form-check form-switch ps-0">
                <input
                  class="form-check-input ms-auto"
                  type="checkbox"
                  id="isActiveTypes"
                  checked
                  v-model="form.is_active"
                />
                <label
                  class="form-check-label text-body ms-3 text-truncate w-80 mb-0"
                  for="isActiveTypes"
                  >啟用</label
                >
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn bg-gradient-secondary"
              data-bs-dismiss="modal"
              id="closeModalBtn"
            >
              取消
            </button>
            <button
              type="button"
              class="btn bg-gradient-primary"
              @click="submitForm"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import Swal from "sweetalert2";
import { hasPermission } from "@/utils/permissions";
import { Modal } from "bootstrap";

export default {
  name: "LanguageSettings",
  data() {
    return {
      languages: [],
      isEditing: false,
      form: {
        id: null,
        code: "",
        name: "",
        native_name: "",
        is_active: true,
        is_default: false,
      },
      modalInstance: null,
      currentUser: JSON.parse(localStorage.getItem("user") || "{}"),
    };
  },
  methods: {
    can(permission) {
      // Fallback to true if permission check fails or not implemented
      if (typeof hasPermission === "function") {
        return hasPermission(this.currentUser, permission);
      }
      return true;
    },
    async fetchLanguages() {
      try {
        const response = await request.get("/api/admin/languages");
        this.languages = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    openModal(lang = null) {
      if (lang) {
        this.isEditing = true;
        this.form = { ...lang };
      } else {
        this.isEditing = false;
        this.form = {
          id: null,
          code: "",
          name: "",
          native_name: "",
          is_active: true,
          is_default: false,
        };
      }

      const modalEl = document.getElementById("languageModal");
      if (modalEl) {
        this.modalInstance = new Modal(modalEl);
        this.modalInstance.show();
      }
    },
    async submitForm() {
      try {
        if (this.isEditing) {
          await request.put(`/api/admin/languages/${this.form.id}`, this.form);
        } else {
          await request.post("/api/admin/languages", this.form);
        }

        // Close modal manually if needed or just reload
        document.getElementById("closeModalBtn").click();

        Swal.fire("成功", "儲存成功", "success");
        this.fetchLanguages();
      } catch (error) {
        console.error(error);
      }
    },
    async toggleActive(lang) {
      // Don't disable default language
      if (lang.is_default && lang.is_active) {
        Swal.fire("錯誤", "無法停用預設語系", "error");
        return;
      }

      try {
        await request.put(`/api/admin/languages/${lang.id}`, {
          ...lang,
          is_active: !lang.is_active,
        });
        this.fetchLanguages();
      } catch (error) {
        console.error(error);
      }
    },
    async setDefault(lang) {
      if (!lang.is_active) {
        Swal.fire("錯誤", "無法將停用的語系設為預設", "error");
        return;
      }

      try {
        await request.put(`/api/admin/languages/${lang.id}`, {
          ...lang,
          is_default: true,
        });
        this.fetchLanguages();
      } catch (error) {
        console.error(error);
      }
    },
    async deleteLanguage(id) {
      const result = await Swal.fire({
        title: "確定刪除?",
        text: "刪除後無法復原!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "是的, 删除!",
        cancelButtonText: "取消",
      });

      if (result.isConfirmed) {
        try {
          await request.delete(`/api/admin/languages/${id}`);
          Swal.fire("已刪除!", "語系已被刪除.", "success");
          this.fetchLanguages();
        } catch (error) {
          // handled by request interceptor
          console.error(error);
        }
      }
    },
  },
  created() {
    this.fetchLanguages();
  },
};
</script>
